/**
 * Page informative « Moyens de paiement ». Porté à l'identique depuis
 * apps/web/app/(shop)/paiement/page.tsx (page statique, aucune adaptation
 * nécessaire au-delà de l'abandon de `generateMetadata`, hors périmètre — cf.
 * lot SEO/prérendu séparé, même traitement que AProposPage.tsx).
 */
export function PaiementPage() {
  return (
    <div className="container-vvs py-8 lg:py-12">
      <h1 className="font-display text-2xl font-bold text-navy sm:text-3xl">Moyens de paiement</h1>
      <div className="mt-4 max-w-prose space-y-6 font-body text-sm leading-relaxed text-muted">
        <p>
          VVS propose deux modes de paiement, choisis parce qu&apos;ils correspondent aux
          habitudes les plus répandues en Côte d&apos;Ivoire&nbsp;: le paiement à la livraison et
          le mobile money. Vous choisissez celui qui vous convient au moment de valider votre
          commande.
        </p>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Paiement à la livraison</h2>
          <p className="mt-1">
            Vous réglez en espèces directement au livreur, au moment de la réception de votre
            commande. Vous pouvez ainsi vérifier votre article avant de payer&nbsp;: c&apos;est le
            mode le plus utilisé sur VVS.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Mobile money</h2>
          <p className="mt-1">
            Vous pouvez également régler par mobile money. Les modalités précises (opérateur et
            numéro à utiliser) vous sont indiquées dans le tunnel de commande au moment de choisir
            ce mode de paiement.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Ce que VVS ne propose pas aujourd&apos;hui</h2>
          <p className="mt-1">
            Le paiement par carte bancaire en ligne n&apos;est pas disponible pour le moment.
            Seuls le paiement à la livraison et le mobile money sont proposés.
          </p>
        </div>
      </div>
    </div>
  );
}
